import { atom } from 'recoil';

export const profileDetailState = atom({
    key: "profileDetailState",
    default: {
        profiles: [
        ]
    }
});